/**
 * Mette `value` sotto `key` come voce più recente e scarta le più vecchie oltre `max` (la Map tiene l'ordine
 * d'inserimento): le ultime risposte viste, per mostrarle subito tornando su una pagina mentre si rileggono.
 */
export function remember<K, V>(cache: Map<K, V>, key: K, value: V, max: number): void {
  cache.delete(key)
  cache.set(key, value)
  for (const oldest of cache.keys()) {
    if (cache.size <= max) break
    cache.delete(oldest)
  }
}

/** Chiave di una risorsa letta da un ospite: percorso e token (vuoto senza ospite). */
export const resourceKey = (path: string, guestToken: string | undefined): string => `${path}|${guestToken ?? ''}`

/** Due chiavi dello stesso ospite (o entrambe senza): solo così i dati dell'una possono reggere l'altra. */
export const sameGuest = (a: string, b: string): boolean => a.slice(a.lastIndexOf('|')) === b.slice(b.lastIndexOf('|'))
